import { AnimateIconSwitcher } from '@consta/icons/AnimateIconSwitcher'
import type { IconPropSize } from '@consta/icons/Icon'
import { IconFavoriteFilled } from '@consta/icons/IconFavoriteFilled'
import { IconFavoriteStroked } from '@consta/icons/IconFavoriteStroked'
import cn from 'classnames'
import type { FC, MouseEventHandler } from 'react'

import css from './FavoriteButton.css'

type FavoriteButtonProps = {
  size?: IconPropSize
  className?: string
  isFavorite: boolean
  onClick: MouseEventHandler
}

export const FavoriteButton: FC<FavoriteButtonProps> = ({
  size,
  className,
  onClick,
  isFavorite,
}) => {
  return (
    <AnimateIconSwitcher
      className={cn(css.favorite, className)}
      title={isFavorite ? 'Убрать из избранного' : 'Добавить в избранное'}
      size={size}
      active={isFavorite}
      startIcon={IconFavoriteStroked}
      endIcon={IconFavoriteFilled}
      onClick={onClick}
    />
  )
}
